/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import React, { FC } from 'react';
import { ConfigProvider } from 'antd';
import { themeConfig } from './theme.config';

interface IThemeProvider {
  children: React.ReactNode;
}

const ThemeProvider: FC<IThemeProvider> = ({ children }) => {
  return <ConfigProvider theme={themeConfig}>{children}</ConfigProvider>;
};

export default ThemeProvider;
